import { render } from "./MultiCreate.vue?vue&type=template&id=2a2fb3cd"
import script from "./MultiCreate.vue?vue&type=script&lang=js"
export * from "./MultiCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__